module.exports = "<div class=\"spinner-block\" *ngIf=\"spinner.show || spinner.loader\"  [ngClass]=\"{'transparent' : spinner.loader}\">\n    <div class=\"spinner\"></div>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// /Users/avihayev/Phone-Plans/Lading Page/landing-page-web/src/app/modules/spinner/spinner.component.html
// module id = ../../../../../src/app/modules/spinner/spinner.component.html
// module chunks = main